import { yellowColor } from "../theme";

export const DASHBOARD_COLORS = {
    done: "#2EBD6B",
    doneDark: "#1E7D4F",
    toCome: "#18B7D9",
    cancelled: "#E25555",
    neutral: "#7C8492",
    highlight: "#3E6FD3",
    orange: "#F08C3C",
    capacity: yellowColor,
    // Linhas de TOTAL/agregado sobrepostas às séries por categoria. Escuro de propósito: lê-se como o
    // agregado e não colide com nenhuma cor de categoria — em particular com o `neutral` cinzento, que
    // muitos gráficos já usam para a categoria "Desconhecido".
    total: "#2F3542",
};

export const GAUGE_BAND_COLORS = {
    low: "#E25555",
    middle: "#F2B33D",
    high: "#2EBD6B",
};

// Paleta para séries dinâmicas (uma linha por pessoa). Atribuída por índice estável para que a cor
// de cada pessoa seja determinística entre renders.
export const SERIES_PALETTE = [
    "#3E6FD3",
    "#F08C3C",
    "#2EBD6B",
    "#E25555",
    "#9C5BD6",
    "#18B7D9",
    "#C8A93B",
    "#D6589C",
    "#5B8C5A",
    "#8492A6",
    "#C2502E",
    "#2E8B8B",
    "#A0522D",
    "#6A5ACD",
    "#208860",
    "#B0398E",
    "#7E8B1F",
    "#5577C0",
];

export const paletteColorAt = (index: number) => {
    const color = SERIES_PALETTE[((index % SERIES_PALETTE.length) + SERIES_PALETTE.length) % SERIES_PALETTE.length];
    return color;
};
